import { useEcommApp } from '@jane/shared/providers';

import { EmbeddedCartDrawer } from './embeddedCartDrawer';
import { MarketplaceCartDrawer } from './marketplaceCartDrawer';

export const PendingCartDrawer = () => {
  const { isIframe } = useEcommApp();

  if (isIframe) return <EmbeddedCartDrawer />;

  return <MarketplaceCartDrawer />;
};
